import { SET_APP_BOOTSTRAP_PHASE } from '../app/actions'
import { SET_AUTH_LOGIN_SUCCESS } from '../auth/actions'
import { getAuthIsLoggedIn } from '../auth/index'
import {
  invokeImpactIdentify,
  stateResolverQueryHasImRef,
  syncImpactImRefCookieFromState,
} from '.'

/**
 * External Impact links land with im_ref on first load; hydrated resolver query is
 * available when bootstrap completes (no in-app links carry im_ref).
 */
export function watchImpactImRefCookie ({ after }) {
  return after(SET_APP_BOOTSTRAP_PHASE, async ({ state, prevState }) => {
    const { app } = state
    const { app: prevApp } = prevState
    if (!prevApp.get('bootstrapComplete') && app.get('bootstrapComplete')) {
      syncImpactImRefCookieFromState(state)
    }
  })
    .when(stateResolverQueryHasImRef)
}

export function watchImpactIdentifyOnBootstrap ({ after }) {
  return after(SET_APP_BOOTSTRAP_PHASE, async ({ state, prevState, dispatch }) => {
    const { app } = state
    const { app: prevApp } = prevState
    const { auth, user } = state
    if (!prevApp.get('bootstrapComplete') && app.get('bootstrapComplete')) {
      await invokeImpactIdentify({ auth, user, dispatch })
    }
  })
}

export function watchImpactIdentifyOnLogin ({ after }) {
  return after(SET_AUTH_LOGIN_SUCCESS, async ({ state, action, dispatch }) => {
    const { auth, user } = state
    if (action.type === SET_AUTH_LOGIN_SUCCESS && getAuthIsLoggedIn(auth)) {
      syncImpactImRefCookieFromState(state)
      await invokeImpactIdentify({ auth, user, dispatch })
    }
  })
}
